// src/components/Header/Header.tsx
import React from 'react';
import styles from './HowItWorks.module.css';
import entreprise from '../../assets/images/entreprise.jpeg';
import { useTranslation } from 'react-i18next';

const HowItWorks: React.FC = () => {

  const { t, i18n } = useTranslation();

  return (
    <div className={styles.infoSection} id="howItWorks">

      <div>
        <h3 className={styles.infoTitle}>
          <span>{t('whoWeAre')}</span>
        </h3>
        <div className={styles.baContainer}>
          <div className={styles.baTextContent}>
            <p className={`${styles.baDescription} ${i18n.language === 'ar' ? styles.arabic : ''
              }`} >
              <strong>Carottage Pro</strong> {t('whoWeAreDescription')} <strong>BTP</strong>, {t('whoWeAreDescription2')}<br />
              {t('whoWeAreDescription3')}
              <br />
              {t('whoWeAreDescription4')}
              <br />
              {t('whoWeAreDescription5')}
            </p>
          </div>
          <div className={styles.baImageContent}>
            <img src={entreprise} alt="Carottage Pro" />
          </div>

        </div>
      </div>





    </div>

  );
}

export default HowItWorks;
